import useFetch from '@hooks/useFetch';
import { getCMSHost } from '@utils/api-helper/host';

const CMSHost = getCMSHost();
export const getSubsriptionFeaturesKey = (goalUid) =>
  `${CMSHost}subscription-features/iconic-${goalUid}`;

const useSubsriptionFeatures = (goalUID) => {
  const { data, ...rest } = useFetch(getSubsriptionFeaturesKey(goalUID), {
    useAuthToken: false
  });
  return { subscriptionData: data, ...rest };
};

export default useSubsriptionFeatures;
